import { FormDataArgs } from '../constants/constants';
import { addMetaData, clearEmptyValues, getFileName } from './functions';

export const downloadJson = (data: FormDataArgs) => {
  const clearedData = clearEmptyValues(data) as FormDataArgs;
  const withMetaData = addMetaData(clearedData);

  const jsonData = JSON.stringify(withMetaData, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json' });

  const link = document.createElement('a');

  link.download = getFileName({
    student: withMetaData.formData.registration.student,
    birthYear: withMetaData.formData.registration.birthYear,
    extension: 'json',
  });

  link.href = URL.createObjectURL(blob);

  link.click();

  URL.revokeObjectURL(link.href);
};
